import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import DropDownTreeProps from './DropDownTreeProps'

import Animation from './Animation'
import Checkboxes from './Checkboxes'
import Messages from './Messages'
import Popup from './Popup'

export default {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: DropDownTreeProps,
    model:{
        event: 'changemodel'
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        Animation,
        Checkboxes,
        Messages,
        Popup
    ],
    mounted() {
        var that = this

        kendo.jQuery(this.$el).kendoDropDownTree(that.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }

        that.kendoWidget().bind('change', function(){
            if(that.v3){
                that.$emit('update:modelValue', that.kendoWidget().value())
            } else {
                that.$emit('changemodel', that.kendoWidget().value())
            }
        })
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoDropDownTree()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowntree-vue-wrapper/src/KendoDropDownTree/KendoDropDownTreeMixin.js